import { API_BASE } from './api';

const SESSION_KEY = 'web_tracking_session_v1';
const USER_KEY = 'web_user_v1';
const TOKEN_KEY = 'web_token_v1';

function safeParse(json) {
  try { return JSON.parse(json); } catch { return null; }
}

export function getTrackingSessionId() {
  if (typeof window === 'undefined') return '';
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    const rnd = Math.random().toString(36).slice(2);
    id = `s_${Date.now()}_${rnd}`;
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

function getWebUserId() {
  if (typeof window === 'undefined') return null;
  const u = safeParse(localStorage.getItem(USER_KEY) || 'null');
  return u?.id || null;
}

function getToken() {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem(TOKEN_KEY) || '';
}

function clean(obj) {
  const out = {};
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    out[k] = v;
  });
  return out;
}

export function track(path, payload = {}) {
  if (typeof window === 'undefined') return;

  const token = getToken();
  const body = JSON.stringify(clean({
    session_id: getTrackingSessionId(),
    web_user_id: getWebUserId(),
    path: window.location.pathname + window.location.search,
    referrer: document.referrer || '',
    ...payload,
  }));

  const url = `${API_BASE}${path}`;

  // sendBeacon سبک‌تر است و صفحه را کند نمی‌کند. اگر نشد، fetch بی‌صدا اجرا می‌شود.
  try {
    if (navigator.sendBeacon && !token) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }
  } catch {}

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body,
    keepalive: true,
  }).catch(() => {});
}

export function trackPageView(payload = {}) {
  track('/api/track/page-view', payload);
}

export function trackProductEvent(eventType, payload = {}) {
  track('/api/track/product-event', {
    event_type: eventType,
    ...payload,
  });
}

export function trackSearch(query, resultCount = 0, payload = {}) {
  track('/api/track/search', {
    query,
    result_count: resultCount,
    ...payload,
  });
}

export function trackPreinvoiceEvent(eventType, payload = {}) {
  track('/api/track/preinvoice-event', {
    event_type: eventType,
    ...payload,
  });
}
